// The laser camera's line beside Add Sheet (and at the top of the Add Sheet dialog): the API's sentence for what
// the camera is doing (features/queue/laserCamera.js cameraLineView). Mode off, or nothing to say: nothing at all.
import React from 'react';
import { cameraLineView, cameraToneStyle } from '../features/queue/laserCamera';

export default function LaserCameraLine({ camera, style = null }) {
  const view = cameraLineView(camera);
  if (!view) return null;
  return (
    <div
      data-testid="laser-camera-line"
      data-status={view.status || ''}
      data-tone={view.tone}
      role={view.tone === 'warn' ? 'alert' : 'status'}
      style={{
        padding: '0.45rem 0.7rem', borderRadius: '6px', fontSize: '0.9rem',
        ...cameraToneStyle(view.tone),
        ...(style || {}),
      }}
    >
      <span aria-hidden="true">📷 </span>
      {view.tone === 'warn' ? <strong>{view.text}</strong> : view.text}
    </div>
  );
}
